<template>
    <h2 class="heading">Interview (Media) Log Form</h2>
    <div class="form">
        <el-form :model="interview" label-width="250px" style="width:800px" >
            <el-form-item label="Media name" required>
                <el-input v-model="interview.mediaName" minlength="2" maxlength="150" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Date of activity" required>
                <el-date-picker v-model="interview.activityDate" type="date" placeholder="Date of activity" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="Nature" required>
                <el-select v-model="interview.type" placeholder="Select nature" style="width:220px">
                    <el-option v-for="t in types" :key="t" :label="t" :value="t"/>
                </el-select>
                <el-input v-model="type" v-if="interview.type=='Others'" placeholder="Others please specify"
                    style="width:320px; margin-left:10px;" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Arranged by">
                <el-select v-model="interview.internalLead" placeholder="Select arranged by" style="width:220px">
                    <el-option v-for="lead in leaders" :key="lead" :label="lead" :value="lead"/>
                </el-select>
                <el-input v-model="internalLead" v-if="interview.internalLead=='Others'" placeholder="Others please specify"
                    style="width:320px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Speaker" required>
                <el-select v-model="interview.speaker" placeholder="Select arranged by" style="width:220px">
                    <el-option v-for="speaker in speakers" :key="speaker" :label="speaker" :value="speaker"/>
                </el-select>
                <el-input v-model="speaker" v-if="interview.speaker=='Others'" placeholder="Others please specify"
                    style="width:320px; margin-left:10px;" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="External lead" required>
                <el-input v-model="interview.externalLead" maxlength="150" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="City">
                <el-input v-model="interview.city" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Interviewer" required>
                <el-input v-model="interview.interviewer" maxlength="250" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Interviewee" required>
                <el-select v-model="interview.interviewee" placeholder="Select interviewee" style="width:220px;margin-right:10px;" @change="selectInterviewee">
                    <el-option v-for="leader in leaders" :key="leader" :label="leader" :value="leader"/>
                </el-select>
                <template v-if="interviewee != ''">
                    <el-tag v-for="inter in interviewee.split(',')" :key="inter" closable @close="removeInterviewee(inter)">{{inter}}</el-tag>
                </template>
            </el-form-item>
            <el-form-item label="Topic" required>
                <el-input v-model="interview.topic" type="textarea" maxlength="1000" rows="4" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Talking points">
                <el-input v-model="interview.talkingPoints" type="textarea" maxlength="30000" rows="6" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Date of publication" required>
                <el-date-picker v-model="interview.pubDate" type="date" placeholder="Date of publication" value-format="YYYY-MM-DD"/>
            </el-form-item>
            <el-form-item label="Costs if applicable">
                <el-input v-model="interview.costs" maxlength="1000" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Addional notes">
                <el-input v-model="interview.remarks" maxlength="150" show-word-limit="true"/>
            </el-form-item>
            <!-- <el-form-item label="Status" required>
                <el-radio-group v-model="event.status">
                    <el-radio label="draft" class="approved">Draft</el-radio>
                    <el-radio label="pending" class="rejected">Submit for approval</el-radio>
                </el-radio-group>
            </el-form-item> -->
            
            <el-form-item label="">
                <el-button type="primary" @click="submitInterview">Submit</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
const types = ["Interview", "Premia event - listing", "Premia event - listing & panel discussion", "Intro to smart beta", 
                "Written interview", "Phone Interview", "Quick phone call", "Others"];
const leaders = ["Rebecca", "David", "Laura", "Frederick", "Others"];
const speakers = ["Rebecca", "David", "Laura", "Frederick", "Others"];
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            types, leaders, speakers,
            speaker: '', type: '', attendeeRole: '', internalLead: '', interviewee: '',
            interview: {
                id: null,
                mediaName: '',
                activityDate: '',
                type: '',
                internalLead: '',
                speaker: '',
                externalLead: '',
                city: '',
                interviewer: '',
                interviewee: '',
                topic: '',
                talkingPoints: '',
                pubDate: '',
                costs: '',
                remarks: '',
            },
            loading: false,
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "interview";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/log/getInterviewByCode", {code: code});
            if (result.success) {
                this.interview = result.data;
                if (types.indexOf(this.interview.type) == -1) {
                    this.type = this.interview.type;
                    this.interview.type = "Others";
                }
                if (leaders.indexOf(this.interview.internalLead) == -1) {
                    this.internalLead = this.interview.internalLead;
                    this.interview.internalLead = "Others";
                }
                if (speakers.indexOf(this.interview.speaker) == -1) {
                    this.speaker = this.interview.speaker;
                    this.interview.speaker = "Others";
                }
                this.interviewee = this.interview.interviewee;
                this.interview.interviewee = "";
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        selectInterviewee() {
            if (this.interview.interviewee != '' && this.interviewee.indexOf(this.interview.interviewee) == -1) {
                this.interviewee = this.interviewee == '' ? this.interview.interviewee : 
                                                            this.interviewee + "," + this.interview.interviewee;
            }
        },
        removeInterviewee(item) {
            this.interviewee += ","
            this.interviewee = this.interviewee.replace(item+",", "")
            this.interviewee = this.interviewee.substring(0, this.interviewee.length-1)
        },
        async submitInterview() {
            this.errMsg = "";
            if (this.interview.mediaName == "") {
                this.errMsg = "[Media name] is required"; return;
            }
            if (this.interview.activityDate == "") {
                this.errMsg = "[Activity date] is required"; return;
            }
            if (this.interview.type == "") {
                this.errMsg = "[Nature] is required"; return;
            }
            if (this.interview.type == "Others" && this.type == "") {
                this.errMsg = "Please specify other nature"; return;
            }
            if (this.interview.internalLead == "Others" && this.internalLead == "") {
                this.errMsg = "Please specify other arranged by"; return;
            }
            if (this.interview.speaker == "") {
                this.errMsg = "[Speaker] is required"; return;
            }
            if (this.interview.speaker == "Others" && this.speaker == "") {
                this.errMsg = "Please specify other speaker"; return;
            }
            if (this.interview.interviewer == "") {
                this.errMsg = "[Interviewer] is required"; return;
            }
            if (this.interviewee == "") {
                this.errMsg = "[interviewee] is required"; return;
            }
            if (this.interview.topic == "") {
                this.errMsg = "[Topic] is required"; return;
            }
            if (this.interview.pubDate == "") {
                this.errMsg = "[Date of publication] is required"; return;
            }
            if (this.interview.type == "Others") this.interview.type = this.type;
            if (this.interview.internalLead == "Others") this.interview.internalLead = this.internalLead;
            if (this.interview.speaker == "Others") this.interview.speaker = this.speaker;
            this.interview.interviewee = this.interviewee;

            if (this.loading) return; // avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/log/saveInterview", this.interview);
            if (result.success) {
                this.$router.push("/log/myInterviewList");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
</style>